import React, { useState, useEffect } from 'react';
import api from '../BaseURL/BaseURL';
import { useAuth } from '../Contexts/AuthContext';

const Table = ({ onSave }) => {
  const { token } = useAuth();
  const [wasteData, setWasteData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Fetch Data from API
  const fetchCollectedData = async () => {
    setLoading(true);
    try {
      const response = await api.get('/institution/wastes', {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 && response.data.status) {
        setWasteData(response.data.data); // Store data directly
      } else {
        setError('فشل في جلب البيانات');
      }
    } catch (err) {
      setError('حدث خطأ أثناء جلب البيانات.');
      console.error('Error fetching collected data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollectedData();
  }, [token]);

  return (
    <div className="p-6" dir="rtl">
      <h1 className="text-2xl font-semibold text-right text-gray-700 mb-4">العناصر المضافة</h1>

      {loading ? (
        <p className="text-gray-600 text-right">جاري التحميل...</p>
      ) : error ? (
        <p className="text-red-500 text-right">{error}</p>
      ) : Object.keys(wasteData).length === 0 ? (
        <p className="text-gray-600 text-right">لا توجد بيانات.</p>
      ) : (
        
        <div className="max-h-[600px] overflow-y-auto">
        {Object.keys(wasteData).map((date) => (
          <div key={date} className="mb-8">
<h2 className="text-xl font-bold text-right text-blue-700 mb-4">
📅 بيانات يوم {new Date(date).toLocaleDateString('ar-EG', { weekday: 'long' })} - {date}
</h2>


      
            {Object.keys(wasteData[date]).map((shift) => (
              <div key={shift} className="mb-6">
                <h3 className="text-lg font-semibold text-right text-green-600 mb-2">🔄 مناوبة {shift}</h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-gray-300 text-sm md:text-base">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border border-gray-300 px-4 py-2 text-right">نوع الوجبة</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">المصدر</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">السبب</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">نوع الغذاء</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">وصف الغذاء</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">صالح/غير صالح</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">الوزن الفارغ</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">اجمالي الوزن</th>
                        <th className="border border-gray-300 px-4 py-2 text-right">اسم الموظف</th>
                      </tr>
                    </thead>
                    <tbody>
                      {wasteData[date][shift].map((item, index) => (
                        <tr key={index} className="hover:bg-gray-100">
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.meal_type_name}</td>
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.source_name}</td>
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.reason_name}</td>
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.food_type_name}</td>
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.food_description_name}</td>
                          <td className="border border-gray-300 px-4 py-2 text-right">
                            {item.is_edible === 1 ? 'صالح' : 'غير صالح'}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.empty_weight}</td>
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.total_weight}</td>
                          <td className="border border-gray-300 px-4 py-2 text-right">{item.employee_name}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      
      )}
    </div>
  );
};

export default Table;
